module.exports = __webpack_public_path__ + "img/widgets_old.b5f12b0b.svg";